import { borderRadius, buttonColors, colors, fontsSize, plainColors } from "../UIElements/Elements";

const MenuCategory = ({ categoryName, onClick, isActive }) => {
    return (
        <div
            onClick={onClick}
            title={categoryName}
            className={`flex justify-center items-center relative w-auto p-[1.5vw] h-auto m-[0.25vw] 
                ${isActive ? `${plainColors.lightBlue} text-white` : plainColors.secondary} 
                ${borderRadius.medium} ${fontsSize.m} overflow-hidden whitespace-nowrap text-ellipsis cursor-pointer max-lg:px-[1.5vh]`}
        >
            {categoryName}
        </div>
    );
}

export default MenuCategory;
